import { render, staticRenderFns } from "./me.vue?vue&type=template&id=5822ee77&scoped=true&"
import script from "./me.vue?vue&type=script&lang=ts&"
export * from "./me.vue?vue&type=script&lang=ts&"
import style0 from "./me.vue?vue&type=style&index=0&id=5822ee77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822ee77",
  null
  
)

export default component.exports